module.exports = __webpack_public_path__ + "static/scheme-ac4727bdeb30bc9676d062e052ee7476.png";